import { render, staticRenderFns } from "./ViewStroke.vue?vue&type=template&id=28cf42a6&"
import script from "./ViewStroke.vue?vue&type=script&lang=ts&"
export * from "./ViewStroke.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('28cf42a6')) {
      api.createRecord('28cf42a6', component.options)
    } else {
      api.reload('28cf42a6', component.options)
    }
    module.hot.accept("./ViewStroke.vue?vue&type=template&id=28cf42a6&", function () {
      api.rerender('28cf42a6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dashboards/ViewStroke.vue"
export default component.exports